import PropTypes from 'prop-types'
import React from 'react'

import './styles.scss'
import { ErrorMessage } from '../ErrorMessage'
import { RequiredSpan } from '../RequiredSpan'

const labelClassFunction = (value, errors) => {
  const className = []
  if (value) {
    className.push('valid')
  }
  if (errors && errors.length) {
    className.push('error')
  }
  return className.length ? className.join('-') : ''
}

export class TextBox extends React.Component {
  renderRequired () {
    const { required } = this.props
    if (!required) {
      return <div />
    }
    return <RequiredSpan />
  }

  render () {
    const {
      label,
      value = '',
      onChange,
      onClear,
      errors,
      name,
      onBlur,
      onFocus,
      required,
      type,
      disabled,
      autoComplete,
      autoFocus
    } = this.props
    const className = [ 'nh-textbox' ]
    if (errors && errors.length) {
      className.push('error')
    }
    const val = typeof value === 'function' ? value() : value
    if (typeof name !== 'undefined') {
      return (
        <div className='text-container'>
          <input
            className={className.join(' ')}
            type={type || 'text'}
            value={val || ''}
            onChange={onChange}
            name={name}
            onBlur={onBlur}
            onFocus={onFocus}
            required={required}
            disabled={disabled}
            autoComplete={autoComplete}
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus={autoFocus}
          />
          {onClear && value?.length > 0 && (
            <i
              aria-hidden='true'
              className='fa fa-times-circle clear-text'
              onClick={onClear}
            />
          )}
          <span className='bar' />
          <label id={labelClassFunction(value, errors)}>{label}</label>
          {this.renderRequired()}
          <ErrorMessage errors={errors} />
        </div>
      )
    }
    return null
  }
}

TextBox.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  value: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
  required: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string)
}
